import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getToken } from '../user/User'

export const useClient = (id) => {
    const [companyName, setCompanyName] = useState("")
    const [sector, setSector] = useState(0)
    const [salesPerson, setSalesPerson] = useState(0)
    const [status, setStatus] = useState('New')
    const [statusUpdated, setStatusUpdated] = useState(new Date())
    const [initialPrice, setInitialPrice] = useState(0.0)
    const [monthlyPrice, setMonthlyPrice] = useState(0.0)
    const [initialPaymentDate, setInitialPaymentDate] = useState(new Date())
    const [serviceAgreementStart, setServiceAgreementStart] = useState(new Date())
    const [serviceAgreementEnd, setServiceAgreementEnd] = useState(new Date())
    const [builtWebsite, setBuiltWebsite] = useState(false)
    const [tags, setTags] = useState([])
    const [contactPersonName, setContactPersonName] = useState("")
    const [emailAddress, setEmailAddress] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [notes, setNotes] = useState("")
    const [tasks, setTasks] = useState([])

    useEffect(() => {
        if(id !== null && id !== undefined) {
            const abortCont = new AbortController()
            
            axios.get(process.env.REACT_APP_API_URL + "/api/clients/" + id, {
                signal: abortCont.signal,
                headers: {
                    "Authorization": "Bearer " + getToken()
                }
            })
            .then(res => {
                var data = res.data

                setCompanyName(data.company_name)
                setSector(data.sector)
                setSalesPerson(data.sales_person)
                setStatus(data.status)
                setStatusUpdated(new Date(data.status_updated))
                setInitialPrice(data.initial_price)
                setMonthlyPrice(data.monthly_price)
                setInitialPaymentDate(new Date(data.initial_payment_date))
                if(new Date(data.service_agreement_start).toLocaleDateString('en-CA') == new Date(data.service_agreement_end).toLocaleDateString('en-CA')) {
                    setServiceAgreementStart(new Date())
                    let endDate = new Date()
                    endDate.setDate(new Date().getDate() + 90)
                    setServiceAgreementEnd(endDate)
                } else {
                    setServiceAgreementStart(new Date(data.service_agreement_start))
                    setServiceAgreementEnd(new Date(data.service_agreement_end))
                }
                setBuiltWebsite(data.built_website)
                setTags(data.tags)
                setContactPersonName(data.contact_person)
                setEmailAddress(data.email_address)
                setPhoneNumber(data.phone_number)
                setNotes(data.notes)
                setTasks(data.tasks == null ? [] : data.tasks)
            }).catch(err => {
                if(err.message === "canceled") {
                    return
                }
                console.error(err);
                toast.error("Internal error while loading client")
            })
        
            return () => abortCont.abort()
        }
    }, [id])

    return { 
        id, 
        companyName, setCompanyName,
        sector, setSector,
        salesPerson, setSalesPerson,
        status, setStatus,
        statusUpdated, setStatusUpdated,
        initialPrice, setInitialPrice,
        monthlyPrice, setMonthlyPrice,
        initialPaymentDate, setInitialPaymentDate,
        serviceAgreementStart, setServiceAgreementStart,
        serviceAgreementEnd, setServiceAgreementEnd,
        builtWebsite, setBuiltWebsite,
        tags, setTags,
        contactPersonName, setContactPersonName,
        emailAddress, setEmailAddress,
        phoneNumber, setPhoneNumber,
        notes, setNotes,
        tasks, setTasks,
    }
}